import ContentLayout from '@/layouts/content-layout'
import ProgramManageView from '@/sections/programs/view/program-manage-view'

export default function ProgramManage() {
  return (
    <ContentLayout title="โปรแกรม" backButton>
      <ProgramManageView />
    </ContentLayout>
  )
}
